import { type FC } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import classNames from 'classnames'
import { findResidencyOption, type ResidencyOption } from './residency'
import styles from './AccountResidencySettings.module.scss'

interface AccountResidencySettingsProps {
  residency: string | undefined
}

export const AccountResidencySettings: FC<AccountResidencySettingsProps> = ({ residency }) => {
  if (!residency) {
    return null
  }

  const residencyOption = findResidencyOption(residency)

  if (!residencyOption) {
    return null
  }

  return (
    <Container>
      <Row className='zocks-mb-2'>
        <Col>
          <h4 className='zocks-text-gray-900'>Data residency</h4>
        </Col>
      </Row>
      <Row className='mb-2'>
        <Col>
          <p className='zocks-text-gray-900 p-0 m-0'>
            The country where Zocks stores your meeting and client data. Set when your account was created. This can't be changed.
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <DataStoredInCard option={residencyOption} />
        </Col>
      </Row>
    </Container>
  )
}

const DataStoredInCard: FC<{ option: ResidencyOption }> = ({ option: { label, Flag } }) => (
  <div className='d-flex flex-column zocks-gap-0.25 zocks-p-0.75 rounded-3 border zocks-border-color-gray-200 zocks-bg-color-gray-100'>
    <div className='lead-extra-small zocks-text-gray-600'>Data stored in</div>
    <div className='d-flex align-items-center zocks-gap-0.5'>
      <Flag aria-hidden='true' className={classNames('flex-shrink-0', styles.flag)} />
      <span className='paragraph-medium medium zocks-text-gray-900'>{label}</span>
    </div>
  </div>
)
